import { api } from './client';

// On-prem licence (go-api internal/handlers/license_handlers.go,
// docs/license-management.md). The activation key is only ever masked.

export interface LicenseDetails {
  key: string;
  status: 'active' | 'expired' | 'revoked' | 'superseded' | string;
  subscription_id?: string;
  subscription_status?: string;
  plan_name?: string;
  plan_code?: string;
  plan_type?: string;
  billing_cycle?: string;
  product_slug?: string;
  product_name?: string;
  user_limit?: number | null;
  starts_at?: string | null;
  ends_at?: string | null;
  days_left?: number | null;
  last_checked_at?: string | null;
  last_verified_at?: string | null;
  last_error?: string;
  activated_by?: string;
  activated_at?: string | null;
}

export interface LicenseView {
  /** False when the server has licensing off: nothing is gated. */
  enabled: boolean;
  licensed: boolean;
  reason?: 'not_activated' | 'expired' | 'revoked' | 'unverified' | 'unavailable' | string;
  message?: string;
  expected_product?: string;
  server_host?: string;
  /** Sent to the licence server with the key (server setting LICENSE_SUBDOMAIN). */
  subdomain?: string;
  license?: LicenseDetails;
}

/** Fired by the API client when the server answers 403 LICENSE_REQUIRED. */
export const LICENSE_REQUIRED_EVENT = 'dsshield:license-required';

/** True when the console must not be used: licensing is on and not satisfied. */
export const licenseBlocks = (l: LicenseView | null | undefined): boolean => !!l && l.enabled && !l.licensed;

export const licenseApi = {
  get: () => api.get<LicenseView>('/license').then((r) => r.data),
  activate: (activationKey: string) =>
    api.post<LicenseView>('/license/activate', { activation_key: activationKey }).then((r) => r.data),
  refresh: () => api.post<LicenseView>('/license/refresh').then((r) => r.data),
};
